var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 16C11.4482 16 11.0005 16.4477 11.0005 17C11.0005 17.5523 11.4482 18 12.0005 18C12.5527 18 13.0005 17.5523 13.0005 17C13.0005 16.4477 12.5527 16 12.0005 16ZM22.6705 17.47L14.6205 3.47C14.0906 2.52009 13.0881 1.93137 12.0005 1.93137C10.9128 1.93137 9.91029 2.52009 9.38046 3.47L1.38046 17.47C0.832506 18.3941 0.820562 19.5407 1.34914 20.4761C1.87772 21.4114 2.86612 21.9927 3.94046 22H20.0605C21.1437 22.0107 22.1486 21.4365 22.6894 20.4978C23.2303 19.5592 23.223 18.4018 22.6705 17.47ZM20.9405 19.47C20.7619 19.7876 20.4248 19.983 20.0605 19.98H3.94046C3.57612 19.983 3.23898 19.7876 3.06046 19.47C2.88182 19.1606 2.88182 18.7794 3.06046 18.47L11.0605 4.47C11.2316 4.13603 11.5752 3.92596 11.9505 3.92596C12.3257 3.92596 12.6694 4.13603 12.8405 4.47L20.8905 18.47C21.0926 18.7752 21.1117 19.1665 20.9405 19.49V19.47ZM12.0005 8C11.4482 8 11.0005 8.44772 11.0005 9V13C11.0005 13.5523 11.4482 14 12.0005 14C12.5527 14 13.0005 13.5523 13.0005 13V9C13.0005 8.44772 12.5527 8 12.0005 8Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default ForwardRef;